import {IGenericBoostersConfig} from "../types/IGenericBoostersConfig";
import {getValidBoosterTypesInCategory} from "./validators/get_valid_booster_types_in_category";
import {getValidCategories} from "./validators/get_valid_categories";
import {getRandomElement} from "./get_random_element";

export const getRandomBooster = <TBoosterPrams extends object>(config: IGenericBoostersConfig<TBoosterPrams>, params: TBoosterPrams) => {
    const validCategories = getValidCategories(config, params);
    const category = getRandomElement(validCategories);

    if (!category) {
        return null;
    }

    const validBoosterTypes = getValidBoosterTypesInCategory(config, category, params);
    const type = getRandomElement<IGenericBoostersConfig<TBoosterPrams>[keyof IGenericBoostersConfig<TBoosterPrams>]>(validBoosterTypes);

    return type ? {category, type} : null;
};
import {IGenericBoostersConfig} from "../types/IGenericBoostersConfig";
import {getValidBoosterTypesInCategory} from "./validators/get_valid_booster_types_in_category";
import {getValidCategories} from "./validators/get_valid_categories";
import {getRandomElement} from "./get_random_element";

export const getRandomBooster = <TBoosterPrams extends object>(config: IGenericBoostersConfig<TBoosterPrams>, params: TBoosterPrams) => {
    const validCategories = getValidCategories(config, params);
    const category = getRandomElement(validCategories);

    if (!category) {
        return null;
    }

    const validBoosterTypes = getValidBoosterTypesInCategory(config, category, params);
    const type = getRandomElement<IGenericBoostersConfig<TBoosterPrams>[keyof IGenericBoostersConfig<TBoosterPrams>]>(validBoosterTypes);

    return type ? {category, type} : null;
};
